import { runQuery } from 'js/dato'
import datoLocales from 'js/datoLocales'
import ReviewsBlock from 'js/pages/LandingPages/components/ReviewsBlock'
import React, { useEffect, useState } from 'react'
import useLocale from '../../hooks/useLocale'
import { SPQuery } from './types/SPQuery'

const query = gql`
  fragment ReviewsFields on ReviewsBlockRecord {
    title
    reviews {
      text
    }
  }
  query SPQuery($language: SiteLocale) {
    reviews: performanceLandingPageSection(
      filter: { id: { eq: "W9q-PzedREarodMxMSjOsQ" } }
      locale: $language
    ) {
      contentBlocks {
        ...ReviewsFields
      }
    }
    reviewsFallback: performanceLandingPageSection(
      filter: { id: { eq: "W9q-PzedREarodMxMSjOsQ" } }
      locale: en
    ) {
      contentBlocks {
        ...ReviewsFields
      }
    }
  }
`

const SocialProof = () => {
  const [data, setData] = useState<SPQuery>()
  const { language } = useLocale()
  const locale = datoLocales[language]

  useEffect(() => {
    const getReviewsData = async () => {
      const fetchedData = await runQuery(query, { locale }, false)
      setData(fetchedData)
    }
    getReviewsData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const reviewsData =
    data?.reviews?.contentBlocks[0] || data?.reviewsFallback?.contentBlocks[0]

  if (reviewsData?.__typename !== 'ReviewsBlockRecord' || !reviewsData) {
    return null
  }

  return (
    <>
      {data && (
        <ReviewsBlock
          title={reviewsData?.title as string}
          reviews={reviewsData?.reviews}
        />
      )}
    </>
  )
}

export default SocialProof
